export const ROUTE_SEGMENTS = {
  AUTH: 'auth',
  LOGIN: 'login',
  UNAUTHORIZED: 'unauthorized',
  CHANGE_PASSWORD: 'change-password',
  DASHBOARD: 'dashboard',
  PATIENTS: 'patients',
  ORGANIZATION: 'organization',
  DOCTORS: 'doctors',
  APPOINTMENTS: 'appointments',
  BILLING: 'billing',
  PHARMACY: 'pharmacy',
  PAYROLL: 'payroll',
  PROFILE: 'profile',
  SETTINGS: 'settings',
  IMPORT: 'import',
  WILDCARD: '**',
} as const;

export const APP_ROUTES = {
  dashboard: `/${ROUTE_SEGMENTS.DASHBOARD}`,
  patients: `/${ROUTE_SEGMENTS.PATIENTS}`,
  organization: `/${ROUTE_SEGMENTS.ORGANIZATION}`,
  doctors: {
    root: `/${ROUTE_SEGMENTS.DOCTORS}`,
    new: `/${ROUTE_SEGMENTS.DOCTORS}/new`,
    detail: (id: string) => `/${ROUTE_SEGMENTS.DOCTORS}/${id}`,
    edit: (id: string) => `/${ROUTE_SEGMENTS.DOCTORS}/${id}/edit`,
    availability: (id: string) => `/${ROUTE_SEGMENTS.DOCTORS}/${id}/availability`,
    mywork: (id: string) => `/${ROUTE_SEGMENTS.DOCTORS}/${id}/mywork`,
  },
  appointments: {
    root: `/${ROUTE_SEGMENTS.APPOINTMENTS}`,
    settings: `/${ROUTE_SEGMENTS.APPOINTMENTS}/settings`,
    detail: (id: string) => `/${ROUTE_SEGMENTS.APPOINTMENTS}/${id}`,
    print: (id: string) => `/${ROUTE_SEGMENTS.APPOINTMENTS}/${id}/print`,
  },
  billing: {
    root: `/${ROUTE_SEGMENTS.BILLING}`,
    new: `/${ROUTE_SEGMENTS.BILLING}/new`,
    detail: (id: string) => `/${ROUTE_SEGMENTS.BILLING}/${id}`,
    edit: (id: string) => `/${ROUTE_SEGMENTS.BILLING}/${id}/edit`,
    print: (id: string) => `/${ROUTE_SEGMENTS.BILLING}/${id}/print`,
  },
  pharmacy: {
    root: `/${ROUTE_SEGMENTS.PHARMACY}`,
    billing: `/${ROUTE_SEGMENTS.PHARMACY}/billing`,
    newBilling: `/${ROUTE_SEGMENTS.PHARMACY}/billing/new`,
    medicines: `/${ROUTE_SEGMENTS.PHARMACY}/medicines`,
    categories: `/${ROUTE_SEGMENTS.PHARMACY}/categories`,
    manufacturers: `/${ROUTE_SEGMENTS.PHARMACY}/manufacturers`,
    suppliers: `/${ROUTE_SEGMENTS.PHARMACY}/suppliers`,
    batchRecords: `/${ROUTE_SEGMENTS.PHARMACY}/batch-records`,
    inventory: `/${ROUTE_SEGMENTS.PHARMACY}/inventory`,
    addStock: `/${ROUTE_SEGMENTS.PHARMACY}/inventory/add`,
    purchases: `/${ROUTE_SEGMENTS.PHARMACY}/purchases`,
    newPurchaseOrder: `/${ROUTE_SEGMENTS.PHARMACY}/purchases/orders/new`,
    purchaseOrder: (id: string) => `/${ROUTE_SEGMENTS.PHARMACY}/purchases/orders/${id}`,
    editPurchaseOrder: (id: string) => `/${ROUTE_SEGMENTS.PHARMACY}/purchases/orders/${id}/edit`,
    settings: `/${ROUTE_SEGMENTS.PHARMACY}/settings`,
  },
  payroll: {
    root: `/${ROUTE_SEGMENTS.PAYROLL}`,
    employees: `/${ROUTE_SEGMENTS.PAYROLL}/employees`,
    newEmployee: `/${ROUTE_SEGMENTS.PAYROLL}/employees/new`,
    employeeDetail: (id: string) => `/${ROUTE_SEGMENTS.PAYROLL}/employees/${id}`,
    employeeEdit: (id: string) => `/${ROUTE_SEGMENTS.PAYROLL}/employees/${id}/edit`,
    offerLetters: `/${ROUTE_SEGMENTS.PAYROLL}/offer-letters`,
    internshipCertificates: `/${ROUTE_SEGMENTS.PAYROLL}/internship-certificates`,
    salaryStructures: `/${ROUTE_SEGMENTS.PAYROLL}/salary-structures`,
    employeeSalaryStructures: `/${ROUTE_SEGMENTS.PAYROLL}/employee-salary-structures`,
    newEmployeeSalaryStructure: (id: string) => `/${ROUTE_SEGMENTS.PAYROLL}/employee-salary-structures/new/${id}`,
    separation: `/${ROUTE_SEGMENTS.PAYROLL}/separation`,
    settings: `/${ROUTE_SEGMENTS.PAYROLL}/settings`,
  },
  auth: {
    root: `/${ROUTE_SEGMENTS.AUTH}`,
    login: `/${ROUTE_SEGMENTS.AUTH}/${ROUTE_SEGMENTS.LOGIN}`,
    unauthorized: `/${ROUTE_SEGMENTS.AUTH}/${ROUTE_SEGMENTS.UNAUTHORIZED}`,
    changePassword: `/${ROUTE_SEGMENTS.AUTH}/${ROUTE_SEGMENTS.CHANGE_PASSWORD}`,
  },
  profile: `/${ROUTE_SEGMENTS.PROFILE}`,
  settings: `/${ROUTE_SEGMENTS.SETTINGS}`,
  import: `/${ROUTE_SEGMENTS.IMPORT}`,
} as const;
